import React, { useState /* , useCallback */ } from 'react';
import styles from './index.module.less';
import {
  Radio,
  //Button,
  Row,
  Col,
  Card,
  Empty,

  // Tooltip,
  Tag,
  // Popconfirm,
  // Space,
  Button
} from 'antd';
//import plus from '../../images/plus.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import { PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { history } from 'app/history';
//import moment from 'moment';
import AllExportReports from '../reports/AllExportReports';
//import { Value_of_gift } from '../../../../utilities/helpers';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function UnmappedBusFlowPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  admin_unmapped_bus,
  admin_unmapped_busPagination,
  admin_unmapped_busLoading,
  setSearchRequest

  //showDisablePopup
  // setShowDisablePopup,
  // handleDeleteRequest
}) {
  // const admin_unmapped_busList = admin_unmapped_bus?.map((item) => ({
  //   key: item?.id,
  //   id: item?.id,
  //   buCode: item?.buCode,
  //   buName: item?.buName,
  //   sbgName: item?.sbgName,
  //   createdAt: item?.createdAt
  // }));
  const [isAllExortModalOpen, setAllExortModalOpen] = useState(false);

  const columns = [
    {
      title: 'Project Site Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (name) => {
        return (
          <span style={{ textTransform: 'capitalize' }}>
            {name ? name : 'N/A'}
          </span>
        );
      }
    },
    // {
    //   title: 'SBG Name',
    //   dataIndex: 'sbgName',
    //   key: 'sbgName',
    //   ellipsis: true,
    //   sorter: (a, b) => a?.sbgName?.localeCompare(b?.sbgName),
    //   render: (sbgName) => {
    //     return <span>{sbgName ? sbgName : 'N/A'}</span>;
    //   }
    // },
    // {
    //   title: 'Created At',
    //   dataIndex: 'createdAt',
    //   key: 'createdAt',
    //   ellipsis: true,
    //   sorter: (a, b) => a?.createdAt?.localeCompare(b?.createdAt),
    //   render: (createdAt) => {
    //     return (
    //       <span>
    //         {createdAt ? moment(createdAt).format('DD MMM YYYY') : 'N/A'}
    //       </span>
    //     );
    //   }
    // }
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      width: '120px',
      ellipsis: true,
      //sorter: (a, b) => a?.status?.localeCompare(b?.status),
      render: (isActive, record) => (
        <Tag
          className={`${styles.status_style}`}
          color={
            record?.isActive === true
              ? 'green'
              : record?.isActive === false
              ? 'red'
              : 'transparent'
          }
        >
          {record?.isActive === true ? 'ACTIVE' : 'DEACTIVATED'}
        </Tag>
      )
    }
  ];

  // const visibility = useCallback((record) => {
  //   return showDisablePopup[record.id];
  // }, showDisablePopup);

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        {/*  <Image alt="users_empty_state" src={emptyState} preview={false} /> */}
        <div className={styles.empty_state_text}>
          There are no delegator to display
        </div>
      </span>
    )
  };

  return (
    <div className={`${styles.container}`}>
      <Row className={`${styles.row_container}`}>
        <div className={`${styles.gift_container}`}>
          <div
            className={`${styles.myGift_title}`}
          >{`Configure Unmapped BU's with Project site`}</div>
          <div className={`${styles.myGift_text}`}>
            {`View and manage unmapped BU's with Project site`}
          </div>
        </div>
        <div className={`${styles.declareGift_div}`}>
          <Row>
            {/*  <Button
              className={`${styles.export_button}`}
              onClick={() => setAllExortModalOpen(true)}
            >
              Export
            </Button> */}
            <Button
              className={`${styles.declareGift_button}`}
              icon={<PlusOutlined />}
              onClick={() => history.push('create-unmapped-bus-flow')}
            >
              <span>Add Unmapped BU with Project site</span>
            </Button>{' '}
            <Button
              style={{ marginLeft: '20px' }}
              className={`${styles.declareGift_button}`}
              icon={<ArrowLeftOutlined />}
              onClick={() => history.push('/admin')}
            >
              Back
            </Button>
          </Row>
        </div>
      </Row>
      <div className={`${styles.tabs_container}`}>
        <Row>
          {/* className={`${styles.row_container}`} */}
          <Col span={16}>
            <Radio.Group
              value={radiofilter}
              size="small"
              className={`${styles.button_import_style}`}
            >
              {filters.map((item, index) => {
                return (
                  <Radio.Button
                    value={item.value}
                    key={index}
                    //className={`${styles.RadioButton_import_style}`}
                    onChange={() => {
                      window.localStorage.setItem(
                        'set_Radiofilter',
                        JSON?.stringify(item.value)
                      );
                      setRadiofilter(item.value);
                      setTriggerFilter(true);
                    }}
                  >
                    {item.name}
                  </Radio.Button>
                );
              })}
            </Radio.Group>
          </Col>
          <Col span={8}>
            <SearchBar
              onChange={(e) => {
                setSearchRequest(e.target.value);
                setTriggerFilter(true);
              }}
              className={` ${styles.searchbar}`}
              inputProps={{
                placeholder: 'Search by project site name'
              }}
            />
          </Col>
        </Row>
      </div>
      <Card className={`${styles.cardStyles}`}>
        <div className={`${styles.table_container}`}>
          <CustomTable
            columns={columns}
            dataSource={admin_unmapped_bus}
            locale={locale}
            loading={admin_unmapped_busLoading}
            pagination={{
              current: page,
              pageSize: pageSize,
              showSizeChanger: true,
              size: 'small',
              total: admin_unmapped_busPagination?.total_records || 0,
              onChange: (page, pageSize) => {
                setPage(page);
                setPageSize(pageSize);
              }
            }}
          />
        </div>
      </Card>
      {isAllExortModalOpen ? (
        <AllExportReports
          isAllExortModalOpen={isAllExortModalOpen}
          setAllExortModalOpen={setAllExortModalOpen}
          apiName={'admin_unmapped_bus'}
        />
      ) : (
        ''
      )}
    </div>
  );
}
export default UnmappedBusFlowPage;
